export class LoginDto {
	login: string = "";
	password: string = "";
}